import type { ReactNode } from 'react'
import { Breakpoints } from './Breakpoints'
import { ComponentPage } from './ComponentPage'
import { GettingStarted } from './GettingStarted'
import { HookPage } from './HookPage'
import { Migrating } from './Migrating'
import { Theming } from './Theming'
import { HOOKS } from '../content/hooks'

/**
 * Slug to page body. Overview pages are hand-written prose; everything else is
 * a component page built from the registry entry and its seed example.
 */
const OVERVIEW: Record<string, () => ReactNode> = {
  '': () => <GettingStarted />,
  theming: () => <Theming />,
  breakpoints: () => <Breakpoints />,
  'migrating-from-mui': () => <Migrating />,
}

export function renderPage(slug: string): ReactNode {
  const overview = OVERVIEW[slug]
  if (overview) return overview()
  if (slug in HOOKS) return <HookPage slug={slug} />
  return <ComponentPage slug={slug} />
}
